import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-mystery-school-header-navigation',
  templateUrl: './mystery-school-header-navigation.component.html',
  styleUrls: ['./mystery-school-header-navigation.component.scss'],
})
export class MysterySchoolHeaderNavigationComponent {
  constructor(public router: Router) {}

  classToggled = false;


  public toggleNav() {
    this.classToggled = !this.classToggled;
  }

  navigateToPath(path: string) {
    this.router.navigateByUrl(path);
  }
  currentPath(): string {
    return this.router.url;
  }
}
